import Layout from 'src/layouts/default-layout';
import Head from 'next/head';
import React from 'react';
import Loader from '../common/loader/loader';

export const Index: React.FC = () => {
    return (
        <React.Fragment>
            <Head>
                <title>Home</title>
            </Head>

            <div className="Content flex p-32 justify-center">
                <Loader />
            </div>
        </React.Fragment>
    );
};

export default Layout(Index, { hideFooter: true });
